<div class="modal-header">
  <h3 class="modal-title">Plantillas Disponibles</h3>
  <button type="button" class="close text-primary" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>


<div class="modal-body">

  <form [formGroup]="documentForm" #formDirective="ngForm" (ngSubmit)="onSubmit(formDirective)">
    <div class="form-group">
      <label class="text-form">Plantilla</label>
      <ng-select [items]="templates" bindLabel="text" bindValue="id" placeholder="Seleccione Templates"
        formControlName="templateid"
        (change)="onChange(formDirective,$event)"
        appendTo="body"
        class="form-control px-0 py-0 collaborators">
      </ng-select>
    </div>

    @if (customs.length > 0) {
      <div class="form-group">
        <ng-container formArrayName="itemcustoms">
          <label class="text-form">Campos</label>
          @for (item of itemcustoms.controls; track item; let i = $index) {
            <div>
              <ng-container [formGroup]="item">
                <label>{{item.value.name}}</label>
                <input class="form-control" [value]="item.value.value" formControlName="value">
                <input type="hidden" formControlName="fieldtype" [value]="item.fieldtype">
              </ng-container>
            </div>
          }
        </ng-container>
      </div>
    }

    @if (clauses.length) {
      <div class="form-group">
        <label class="text-form">Cláusulas</label>
        <div class="cuadrar">
          @for (item of itemclauses.controls; track item; let i = $index) {
            <div formArrayName="itemclauses">
              <div class="form-check">
                <div>
                  <input class="form-check-input" type="checkbox" id="{{ item.value.name }}"
                    [value]="item.value.value" [checked]="(item.value.value==true)?true:false"
                    (change)="onCheckboxChange($event,item.value.id)" />
                  <label class="form-check-label" for="{{ item.value.name }}">{{ item.value.name }}</label>
                </div>
              </div>
              <br />
            </div>
          }
        </div>
      </div>
    }

    <div class="d-flex justify-content-end mb-2">
      @if (!bloqk) {
<button class="
                btn btn-outline-primary
                rounded-pill
                text-dark
                px-4
                font-weight-bold" type="submit">
          Generar Template
        </button>
      }
      @if (bloqk && !generate) {
        <span> {{message}}</span>
      }
      @if (generate) {
        <span> Generando Template ...</span>
      }
    </div>

  </form>





</div>
